@value lg-up from "../../../../../../../_shared/breakpoints.module.css";

.customTooltip {
  display: flex;
  flex-direction: column;
  background-color: var(--cont-color-common-container-surface-layer-4);
  box-shadow: var(--lseg-box-shadow-moderate);
}

.tooltipHeader {
  padding: 10px;
  text-align: center;
  font-weight: bold;
  background-color: var(--cont-color-action-bg-neutral-base);
  border-bottom: 1px solid var(--cont-color-menu-border-on-layer-4-moderate);
}

.tooltipList {
  margin: 0;
  padding: 10px;
  list-style: none;
}

.exchangeSelector {
  width: 250px;
  margin: 10px;
}

.tabPaneContent {
  display: flex;
  position: relative;
}

.tabPaneBarAreaTable {
  position: absolute;
  width: 400px;
  right: 10px;
  border: 1px solid var(--cont-color-shell-border-on-layer-1-bold);
  background-color: var(--cont-color-common-container-surface-layer-1);
  box-shadow: var(--lseg-box-shadow-moderate);
}

.tableAreaCloseButton {
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 1;
}

.breakdownTableTitle {
  background-color: var(--cont-color-action-bg-neutral-base);
  text-align: center;
  font-weight: bold;
  padding: 10px;
}

.secondYAxisLine {
  transform: translate(60px, 0px);
}

.graphControlHeader {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media (lg-up) {
  .graphControlHeader {
    position: absolute;
    right: 0px;
    z-index: 1;
  }
}

.graphControlProductSelect {
  margin-left: 5px;
  width: 150px;
}
